// extracted by mini-css-extract-plugin
export default {"viewNavigation":"ViewNavigation_viewNavigation__iyW5P","right":"ViewNavigation_right__Qnd32","next":"ViewNavigation_next__osFOV"};